const pad = (value) => String(Math.abs(value)).padStart(2, '0');

/**
 * Значение <input type="datetime-local"> → timezone-aware ISO.
 * ТЗ (раздел 6) требует отправлять from/to с таймзоной; toISOString() дал бы
 * UTC-строку и сместил бы границы фильтра для пользователя.
 * Пустое или неразбираемое значение даёт undefined, чтобы параметр не ушёл в запрос.
 */
export const toIsoWithOffset = (localValue) => {
  if (!localValue) return undefined;

  const date = new Date(localValue);
  if (Number.isNaN(date.getTime())) return undefined;

  const offsetMinutes = -date.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const offset = `${sign}${pad(Math.trunc(offsetMinutes / 60))}:${pad(offsetMinutes % 60)}`;

  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}${offset}`
  );
};

/** Обратное преобразование — для значений по умолчанию в datetime-local. */
export const toLocalInputValue = (value) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return (
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
};

/**
 * FE-FIX09. Значение фильтра может прийти двумя способами: как ввод
 * datetime-local (`2026-09-24T15:00`) или как готовый ISO с оффсетом из
 * drilldown-ссылки Сводки (`2026-09-24T15:00:00.123456+03:00`). Второй нельзя
 * прогонять через toIsoWithOffset: он потеряет секунды и пересчитает время
 * в пояс браузера, сдвинув границы интервала.
 */
export const isTimezoneAwareIso = (value) =>
  typeof value === 'string' && /(?:Z|[+-]\d{2}:\d{2})$/.test(value);

/** Готовый ISO пропускаем как есть, значение поля — конвертируем. */
export const filterValueToIso = (value) =>
  (isTimezoneAwareIso(value) ? value : toIsoWithOffset(value));
